<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const SlotsTabIcon = getIcon("SlotsTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof SlotsTabIcon === 'string'}
	<img src={SlotsTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof SlotsTabIcon === 'function'}
	<svelte:component this={SlotsTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
